define(
    'providers/dataprovider.templatefolders',[
        "services/config"
    ],
    function(config) {

        function getFolders(templateId) {
            var data = { id: templateId };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-templatefolders-folders",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function addFolder(templateId, name, parentId) {
            var data;

            if(parentId === undefined)
                data = { templateId: templateId, name: name };
            else
                data = { templateId: templateId, parentId: parentId, name: name };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "add-templatefolders-folders",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function createFolder(templateId, name, templatefolderId) {
            var data = { 
                templateId2: templateId,
                templateId: templatefolderId,
                name: name
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "cre-templatefolders-folders",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function renameFolder(templateId, folderId, name) {
            var data = {templateId: templateId, folderId: folderId, name: name};
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "ren-templatefolders-folders",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function deleteFolder(templateId, folderId) {
            var data = { templateId: templateId, folderId: folderId};
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "del-templatefolders-folders",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        init();

        return {
            getFolders: getFolders,
            addFolder: addFolder,
            createFolder: createFolder,
            renameFolder: renameFolder,
            deleteFolder: deleteFolder
        };

        //#region Internal Methods
        function init() {
            amplify.request.define("get-templatefolders-folders", "ajax", {
                url: getUrl("admin/foldertemplates/{id}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("add-templatefolders-folders", "ajax", {
                url: getUrl("admin/foldertemplates/{templateId}/folders"),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("cre-templatefolders-folders", "ajax", {
                url: getUrl("admin/foldertemplates/{templateId2}/folders"),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("ren-templatefolders-folders", "ajax", {
                url: getUrl("admin/foldertemplates/{templateId}/folders/{folderId}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("del-templatefolders-folders", "ajax", {
                url: getUrl("admin/foldertemplates/{templateId}/folders/{folderId}"),
                dataType: "json",
                type: "DELETE"
            });
        }

        function getUrl(action) {
            return config.webApiUrl + action;
        }

        //#endregion
    }
);
